<div>
    @if (goalHasLimit(goal())) {
        <div class="ft-dropdown goal-numbers" [class.active]="numbersOpen()" (click)="toggleNumbers($event)">
            <button class="ft-dropdown-toggle ft-btn ft-btn-outline-dark">
                {{ descriptor()?.value }} <i class="ft-icn-caret-down"></i>
            </button>
            <ul class="ft-dropdown-menu">
                @for (limit of goalLimits; track limit) {
                    <li (click)="setLimit(limit)"><a>{{ limit }}</a></li>
                }
            </ul>
        </div>
    }

    <div class="ft-dropdown goal-types" [class.dropdown-single]="availableGoals().length <= 1" [class.active]="typesOpen()" (click)="toggleTypes($event)">
        <a class="ft-dropdown-toggle" [class.disabled]="availableGoals().length <= 1">
            {{ goalLabel() }} <i class="ft-icn-caret-down"></i>
        </a>
        @if (availableGoals().length > 1) {
            <ul class="ft-dropdown-menu">
                @for (variation of availableGoals(); track variation) {
                    <li (click)="setGoal(variation)">
                        <a>{{ variation.name }}</a>
                    </li>
                }
            </ul>
        }
    </div>
</div>
